import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      nav(loc.state?.from || "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore login");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh]" data-testid="login-page">
      <div className="container-editorial grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#2d6fc4]">— Area clienti</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 leading-[0.9] text-[#2d6fc4]">
            Accedi al tuo <em className="italic text-[#2d6fc4]">dossier</em>.
          </h1>
          <p className="mt-6 text-[#333333] max-w-md">
            Segui lo stato delle trattative in corso, aggiornamenti e documenti — sempre a portata di mano.
          </p>
        </div>
        <form onSubmit={submit} className="col-span-12 md:col-span-6 md:col-start-7 border border-[#E5E7EB] bg-[#FFFFFF] rounded-lg p-8 md:p-10 space-y-6" data-testid="login-form">
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#333333]">Email</span>
            <input required type="email" data-testid="login-email" className="w-full bg-transparent border-b border-[#E5E7EB] py-3 focus:border-[#14417B]" value={email} onChange={e=>setEmail(e.target.value)}/>
          </label>
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#333333]">Password</span>
            <input required type="password" data-testid="login-password" className="w-full bg-transparent border-b border-[#E5E7EB] py-3 focus:border-[#14417B]" value={password} onChange={e=>setPassword(e.target.value)}/>
          </label>
          <button disabled={loading} data-testid="login-submit" className="btn-terracotta w-full py-4 rounded-lg text-sm tracking-wide disabled:opacity-60">
            {loading ? "Accesso…" : "Accedi"}
          </button>
          <p className="text-sm text-[#333333]">
            Non hai ancora un account? <Link to="/register" className="text-[#2d6fc4] link-underline pb-0.5">Registrati</Link>
          </p>
          <div className="text-xs text-[#333333] border-t border-[#E5E7EB] pt-4">
            <p className="font-mono uppercase tracking-[0.2em] text-[10px] mb-1">Demo</p>
            <p>Cliente: <code>cliente@saldoestralcio.it</code> / <code>Cliente123!</code></p>
          </div>
        </form>
      </div>
    </div>
  );
}
